/* ============================================
   CUSTOMER REVIEWS — Airtable-Powered
   Skin Moderne PDP Section
   ============================================ */
(function () {
  'use strict';

  // Reviews are served by a Cloudflare Worker that holds the Airtable token
  // server-side and returns only public, published fields ({reviews,count,averageRating}).
  // No secret or Airtable base/table is exposed in the browser.
  var REVIEWS_ENDPOINT = 'https://skin-moderne-reviews.lior-f64.workers.dev/';
  var CACHE_KEY = 'sm_reviews_cache';
  var CACHE_TTL = 5 * 60 * 1000; // 5 minutes

  // --- Stars HTML ---
  var STAR_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';


  var section = document.querySelector('.sm-reviews');
  if (!section) return;

  var gridEl = section.querySelector('[data-grid]');
  var summaryEl = section.querySelector('[data-summary]');
  var moreBtn = section.querySelector('[data-more]');
  var skeletonEl = section.querySelector('[data-skeleton]');
  var initialCount = parseInt(section.dataset.initialCount, 10) || 6;
  var allReviews = [];
  var visibleCount = 0;

  // --- Lightbox state ---
  var lightboxPhotos = [];
  var lightboxIndex = 0;

  init();

  function init() {
    var cached = getCache();
    if (cached) {
      render(cached);
    } else {
      fetchReviews();
    }
  }

  // --- Cache ---
  function getCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (Date.now() - data.ts > CACHE_TTL) {
        sessionStorage.removeItem(CACHE_KEY);
        return null;
      }
      return data.payload;
    } catch (e) {
      return null;
    }
  }

  function setCache(payload) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), payload: payload }));
    } catch (e) { /* quota exceeded — ignore */ }
  }

  // --- Fetch from Airtable ---
  function fetchReviews() {
    fetch(REVIEWS_ENDPOINT)
      .then(function (r) {
        if (!r.ok) throw new Error('Reviews ' + r.status);
        return r.json();
      })
      .then(function (payload) {
        if (!payload || !payload.reviews) throw new Error('Malformed reviews payload');
        setCache(payload);
        render(payload);
      })
      .catch(function (err) {
        console.error('[SM Reviews]', err);
        if (skeletonEl) skeletonEl.remove();
      });
  }

  function transformReview(r) {
    var f = r.fields;
    return {
      id: f['Review ID'] || r.id,
      name: f['Reviewer Name'] || 'Customer',
      rating: f['Rating'] || 5,
      title: f['Title'] || '',
      body: f['Body'] || '',
      date: f['Date'] || '',
      verified: !!f['Verified'],
      helpfulVotes: f['Helpful Votes'] || 0,
      photos: (f['Photos'] || []).map(function (a) {
        return {
          url: a.url,
          thumb: (a.thumbnails && a.thumbnails.large && a.thumbnails.large.url) || a.url,
          width: a.width,
          height: a.height
        };
      }),
      videos: (f['Videos'] || []).map(function (a) { return { url: a.url }; }),
      featured: !!f['Featured'],
      displayOrder: f['Display Order'] || 9999
    };
  }

  function sortReviews(a, b) {
    if (a.featured !== b.featured) return b.featured ? 1 : -1;
    if (a.displayOrder !== b.displayOrder) return a.displayOrder - b.displayOrder;
    return new Date(b.date) - new Date(a.date);
  }

  function calcAvg(reviews) {
    if (!reviews.length) return 0;
    var sum = reviews.reduce(function (s, r) { return s + (r.rating || 0); }, 0);
    return Math.round((sum / reviews.length) * 10) / 10;
  }

  // --- Render ---
  function render(payload) {
    if (skeletonEl) skeletonEl.remove();
    allReviews = payload.reviews;

    if (!allReviews.length) {
      gridEl.innerHTML = '<div class="sm-reviews__empty">No reviews yet.</div>';
      return;
    }

    renderSummary(payload.averageRating, payload.count);
    showReviews(initialCount);
    updateMoreButton();
    // NOTE: We intentionally do NOT emit review/aggregateRating JSON-LD here.
    // These are brand-wide reviews (identical on every page), and injecting a
    // Brand review node on product pages caused Google Search Console errors
    // ("Invalid object type for field <parent_node>"). Product structured data
    // is already emitted server-side via {{ product | structured_data }}.
  }

  function renderSummary(avg, count) {
    summaryEl.innerHTML =
      '<span class="sm-reviews__avg-value">' + avg.toFixed(1) + '</span>' +
      '<span class="sm-reviews__avg-stars">' + starsHTML(avg, 'sm-reviews') + '</span>' +
      '<span class="sm-reviews__count">Based on ' + count + ' review' + (count !== 1 ? 's' : '') + '</span>';
  }

  function showReviews(count) {
    var end = Math.min(count, allReviews.length);
    for (var i = visibleCount; i < end; i++) {
      gridEl.appendChild(createCard(allReviews[i]));
    }
    visibleCount = end;
    updateMoreButton();
  }

  function updateMoreButton() {
    if (visibleCount >= allReviews.length) {
      moreBtn.setAttribute('hidden', '');
    } else {
      moreBtn.removeAttribute('hidden');
      moreBtn.textContent = 'Show more reviews (' + (allReviews.length - visibleCount) + ' remaining)';
    }
  }

  moreBtn.addEventListener('click', function () {
    showReviews(visibleCount + initialCount);
  });

  // --- Card ---
  function createCard(review) {
    var card = document.createElement('div');
    card.className = 'sm-review' + (review.featured ? ' sm-review--featured' : '');

    var html = '';

    // Stars
    html += '<div class="sm-review__stars">' + starsHTML(review.rating, 'sm-review') + '</div>';

    // Title + verified
    html += '<div class="sm-review__title-row">';
    if (review.title) {
      html += '<h5 class="sm-review__title">' + esc(review.title) + '</h5>';
    }
    if (review.verified) {
      html += '<span class="sm-review__verified">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">' +
        '<path fill-rule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd"/>' +
        '</svg>Verified</span>';
    }
    html += '</div>';

    // Body
    var needsTruncation = review.body.length > 280;
    html += '<div class="sm-review__body' + (needsTruncation ? ' sm-review__body--truncated' : '') + '" data-body>' +
      esc(review.body) + '</div>';
    if (needsTruncation) {
      html += '<button class="sm-review__read-more" data-read-more>Read more</button>';
    }

    // Photos
    if (review.photos.length) {
      html += '<div class="sm-review__photos">';
      var maxShow = 3;
      review.photos.forEach(function (photo, idx) {
        if (idx < maxShow) {
          html += '<div class="sm-review__photo" data-photo-idx="' + idx + '" data-review-id="' + esc(review.id) + '">' +
            '<img src="' + esc(photo.thumb) + '" alt="Review photo" loading="lazy" width="64" height="64">' +
            '</div>';
        }
      });
      if (review.photos.length > maxShow) {
        html += '<div class="sm-review__photo sm-review__photo-more" data-photo-idx="' + maxShow + '" data-review-id="' + esc(review.id) + '">' +
          '+' + (review.photos.length - maxShow) + ' more</div>';
      }
      html += '</div>';
    }

    // Videos
    if (review.videos.length) {
      html += '<div class="sm-review__videos">';
      review.videos.forEach(function (v) {
        html += '<video class="sm-review__video" controls preload="metadata" playsinline>' +
          '<source src="' + esc(v.url) + '">' +
          '</video>';
      });
      html += '</div>';
    }

    // Helpful
    if (review.helpfulVotes > 0) {
      html += '<div class="sm-review__helpful">' + review.helpfulVotes + ' people found this helpful</div>';
    }

    // Footer
    html += '<div class="sm-review__footer">';
    html += '<span class="sm-review__author">' + esc(review.name) + '</span>';
    html += '</div>';

    card.innerHTML = html;

    // Event: read more
    var readMoreBtn = card.querySelector('[data-read-more]');
    if (readMoreBtn) {
      readMoreBtn.addEventListener('click', function () {
        var body = card.querySelector('[data-body]');
        var expanded = body.classList.toggle('sm-review__body--expanded');
        body.classList.toggle('sm-review__body--truncated', !expanded);
        readMoreBtn.textContent = expanded ? 'Show less' : 'Read more';
      });
    }

    // Event: photo lightbox
    var photoEls = card.querySelectorAll('[data-photo-idx]');
    photoEls.forEach(function (el) {
      el.addEventListener('click', function () {
        var rid = el.dataset.reviewId;
        var rev = allReviews.find(function (r) { return r.id === rid; });
        if (!rev) return;
        lightboxPhotos = rev.photos.map(function (p) { return p.url; });
        lightboxIndex = parseInt(el.dataset.photoIdx, 10) || 0;
        if (lightboxIndex >= lightboxPhotos.length) lightboxIndex = 0;
        openLightbox();
      });
    });

    return card;
  }

  
  function starsHTML(rating, prefix) {
    // Sanitize rating input
    rating = parseFloat(rating) || 5;
    rating = Math.min(5, Math.max(0, rating));

    var html = '';
    var full = Math.floor(rating);
    var decimal = rating - full;
    var hasHalf = decimal >= 0.25 && decimal < 0.75;
    var rounded = hasHalf ? full + 0.5 : (decimal >= 0.75 ? full + 1 : full);

    for (var i = 1; i <= 5; i++) {
      if (i <= Math.floor(rounded)) {
        html += '<span class="' + prefix + '__star">' + STAR_SVG + '</span>';
      } else if (i === Math.floor(rounded) + 1 && hasHalf) {
        html += '<span class="' + prefix + '__star ' + prefix + '__star--half">' +
          '<span class="star-base">' + STAR_SVG + '</span>' +
          '<span class="star-fill">' + STAR_SVG + '</span>' +
          '</span>';
      } else {
        html += '<span class="' + prefix + '__star ' + prefix + '__star--empty">' + STAR_SVG + '</span>';
      }
    }
    return html;
  }

  // --- Lightbox ---
  var lightboxEl = null;

  function openLightbox() {
    if (!lightboxEl) createLightboxEl();
    updateLightboxImg();
    lightboxEl.removeAttribute('hidden');
    requestAnimationFrame(function () {
      lightboxEl.classList.add('sm-lightbox--visible');
    });
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', lightboxKeyHandler);
  }

  function closeLightbox() {
    if (!lightboxEl) return;
    lightboxEl.classList.remove('sm-lightbox--visible');
    setTimeout(function () {
      lightboxEl.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }, 200);
    document.removeEventListener('keydown', lightboxKeyHandler);
  }

  function lightboxKeyHandler(e) {
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') lightboxNav(1);
    if (e.key === 'ArrowLeft') lightboxNav(-1);
  }

  function lightboxNav(dir) {
    lightboxIndex = (lightboxIndex + dir + lightboxPhotos.length) % lightboxPhotos.length;
    updateLightboxImg();
  }

  function updateLightboxImg() {
    if (!lightboxEl) return;
    var img = lightboxEl.querySelector('.sm-lightbox__img');
    img.src = lightboxPhotos[lightboxIndex];
  }

  function createLightboxEl() {
    lightboxEl = document.createElement('div');
    lightboxEl.className = 'sm-lightbox';
    lightboxEl.setAttribute('hidden', '');
    lightboxEl.innerHTML =
      '<button class="sm-lightbox__close" aria-label="Close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
      '<button class="sm-lightbox__nav sm-lightbox__nav--prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>' +
      '<img class="sm-lightbox__img" src="" alt="Review photo">' +
      '<button class="sm-lightbox__nav sm-lightbox__nav--next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg></button>';

    lightboxEl.querySelector('.sm-lightbox__close').addEventListener('click', closeLightbox);
    lightboxEl.querySelector('.sm-lightbox__nav--prev').addEventListener('click', function () { lightboxNav(-1); });
    lightboxEl.querySelector('.sm-lightbox__nav--next').addEventListener('click', function () { lightboxNav(1); });
    lightboxEl.addEventListener('click', function (e) {
      if (e.target === lightboxEl) closeLightbox();
    });

    document.body.appendChild(lightboxEl);
  }

  // --- Helpers ---
  function formatDate(iso) {
    try {
      var d = new Date(iso + 'T00:00:00');
      return new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(d);
    } catch (e) {
      return iso;
    }
  }

  function esc(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }
})();
